import { ApplicationProperties } from "@cai-common";
import { AuthenticationMethodEnum, UserTypeEnum } from "@cai-services";
import { AirlineMenuConfig } from "./config/airline-menu.config";
import { ForwarderMenuConfig } from "./config/forwarder-menu.config";

export class AppProperties implements ApplicationProperties {
  name = "cargomart";
  logo = "/assets/media/logos/cargomart.png";
  registerUrl = "/register";
  walletBaseUrl = "/forwarder/settings/wallet-management";
  menu = [
    {
      "userType": UserTypeEnum.AIRLINE,
      "authenticationMethods": [
        AuthenticationMethodEnum.COGNITO,
        AuthenticationMethodEnum.DEV,
        AuthenticationMethodEnum.ANONYMOUS,
        AuthenticationMethodEnum.SYSTEM,
      ],
      "defaultPage": "/airline/quote/quote-list",
      "secondDefaultPage": "/airline/search/airline-search",
      "config": new AirlineMenuConfig(),
    },
    {
      "userType": UserTypeEnum.FORWARDER,
      "authenticationMethods": [
        AuthenticationMethodEnum.COGNITO,
        AuthenticationMethodEnum.DEV,
        AuthenticationMethodEnum.TOKEN,
        AuthenticationMethodEnum.ANONYMOUS,
        AuthenticationMethodEnum.SYSTEM,
      ],
      "defaultPage": "/forwarder/search/forwarder-search",
      "config": new ForwarderMenuConfig(),
    },
  ];
}
